import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationList: {},
  }
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async paginate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.plain-field.paginate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.plain-field.get_record'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.plain-field.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async createPlainFieldAndImportYieldTable({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.plain-field.create_plain_field_and_import_yield_table'),
      payload
    )
    if (apiResult) {
      return apiResult
    }
  },
  async deletePlainFieldAndImportYieldTable({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.plain-field.delete_plain_field_and_import_yield_table'),
      payload
    )
    if (apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
